import script from "./ReferenceHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceHeader.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceHeader.vue?vue&type=style&index=0&id=39e054ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e054ae"]])

export default __exports__